export const PLANS_TABLE_HIGH = [
    {
        id: 1,
        description: 'Cobertura por Robo total',
        all: true,
        allAmount: 'Valor cotizado de tu carro',
        alone: true,
        aloneAmount: 'Valor cotizado de tu carro',
        until: false
    },
    {
        id: 2,
        description: 'Te pagamos por choque (2 eventos al año)',
        all: true,
        allAmount: 'S/1000',
        alone: true,
        aloneAmount: 'S/1000',
        until: false
    },
    {
        id: 3,
        description: 'Grúa y Auxilio mecánico ilimitado',
        all: true,
        allAmount: '',
        alone: true,
        aloneAmount: '',
        until: false
    },
    {
        id: 4,
        description: 'Muerte accidental 5 ocupantes c/u',
        all: true,
        allAmount: 'S/20,000',
        alone: false,
        aloneAmount: '',
        until: false
    },
    {
        id: 5,
        description: 'Invalidez permanente 5 ocupantes c/u',
        all: true,
        allAmount: 'S/20,000',
        alone: false,
        aloneAmount: '',
        until: true
    },
    {
        id: 6,
        description: 'Gastos médicos 5 ocupantes c/u',
        all: true,
        allAmount: 'S/5,000',
        alone: false,
        aloneAmount: '',
        until: true
    },
    {
        id: 7,
        description: 'Gastos sepelio 5 ocupantes c/u',
        all: true,
        allAmount: 'S/2,000',
        alone: false,
        aloneAmount: '',
        until: true
    },
    {
        id: 8,
        description: 'Daños a terceros: materiales o personales',
        all: true,
        allAmount: 'S/20,000',
        alone: false,
        aloneAmount: '',
        until: true
    }
]